import {
  Markdown,
  StripeWrapper,
  Title,
  useUiKitComponents,
} from "@qws-org/ui-kit";
import type { FC } from "react";
import React from "react";

import type { WelcomeOfferBannerItems } from "~/core";

export type WelcomeOfferCardsProps = {
  card: WelcomeOfferBannerItems;
  className?: string;
  href?: string;
  onPress: () => void;
};

export const WelcomeOfferCard: FC<WelcomeOfferCardsProps> = (props) => {
  const { Link } = useUiKitComponents();
  const { card, className, href, onPress } = props;

  const cardContent = (
    <StripeWrapper
      p={{ px: 16, py: 10 }}
      width="100%"
      maxWidth={450}
      minHeight={88}
      onClick={() => {
        if (!href) {
          onPress();
        }
      }}
      md={{
        p: { px: 10 },
        minHeight: 150,
        width: 295,
        m: 0,
      }}
      d={{ p: { px: 10 } }}
      variant="quaternary"
      border={{ radius: "16px" }}
      className={`flex flex-col justify-center ${className ?? ""}`}
    >
      <Title
        as="h4"
        fontSize="headline.mobile.large"
        lineHeight="title.mobile.medium"
        fontWeight="mobile.bold"
        md={{
          fontSize: "title.desktop.medium",
          lineHeight: "title.desktop.medium",
        }}
        horizontalAlign="center"
        bg="text-accent-grad"
        className="bg-clip-text text-transparent break-words"
      >
        {card.title}
      </Title>
      {card.description && (
        <Markdown
          fontSize="body.mobile.large"
          lineHeight="body.mobile.large"
          fontWeight="mobile.bold"
          alignment="center"
          md={{
            fontSize: "title.desktop.small",
            lineHeight: "title.desktop.small",
          }}
        >
          {card.description}
        </Markdown>
      )}
    </StripeWrapper>
  );

  if (href) {
    return (
      <Link className="w-full max-w-[450px]" href={href}>
        {cardContent}
      </Link>
    );
  }

  return cardContent;
};
